import { render, staticRenderFns } from "./IePopup.vue?vue&type=template&id=210011b6&scoped=true&"
import script from "./IePopup.vue?vue&type=script&lang=js&"
export * from "./IePopup.vue?vue&type=script&lang=js&"
import style0 from "./IePopup.vue?vue&type=style&index=0&id=210011b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210011b6",
  null
  
)

export default component.exports